import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { PollService } from '@services/poll.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { CommonPipe } from '@pipes/common.pipe';
import { CategoryService } from '@services/category.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { NgxSmartModalService,NgxSmartModalComponent } from 'ngx-smart-modal';
@Component({
  selector: 'app-epoll',
  templateUrl: './epoll.component.html',
  styleUrls: ['./epoll.component.sass']
})
export class EpollComponent implements OnInit,AfterViewInit {
  error: any = {  };
  component = "";
  btn_process = false;
  tags: any = [];
  is_owner = false;
  params: any = [];
  comments: any = [];
  id = "";
  selected_category = "";
  images: any = [];
  application = "";
  appCreateForm: FormGroup;
  questionEditForm: FormGroup;
  response: any = [];
  status_list:any=[];
  timezone_list:any=[];
  pollJson:any=[];
  pollId='';
  questionForm:any={};
  qupdatebtn_process=false;
  questionId='';
  answeresponse:any=[];
  constructor(public ngxSmartModalService: NgxSmartModalService,private datePipe: DatePipe, private _categoryService: CategoryService, private _commonPipe: CommonPipe, private _viewService: ViewService, private fb: FormBuilder, private _pollService: PollService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "poll";
    this.appCreateForm = this.fb.group({
      name: [],
      timeZone:[],
      description: [],
      status:[],
      startTime:[],
      endTime:[]
    });
    this.questionEditForm = this.fb.group({
      name: [],
      description: [],
      status:[],
      application:[],
      component:[],
      id:[],
     pollId:[]
    });
    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.id = this.params['id'];
      this.pollId=this.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.response = this._global.getVal(data, 'response', '');
            this.pollJson=this.response['pollJson']['questions'];
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'id', ''));
            this.appCreateForm.get("startTime").setValue(new Date(this.response.startTime)); 
            this.appCreateForm.get("endTime").setValue(new Date(this.response.endTime)); 
         let THIS = this;
            let p = {
              'component': this.component,
              'application': 'category',
              'categoryType': this.application
            };
            this._categoryService.application(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.response.category, this.application, true);

                  $("div#" + this.application + "_category").click(function (e) {
                    var $target = $(e.target);
                    if ($target.attr("id") === "categoryCheck") {
                      let result = Helper.getCategoryChecboxValues("categoryCheck", '');
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                  $("div#" + this.application + "_category ul li input").each(function (e) {
                    var $target = $(this);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
    

        let f = {
          'component': this.component,
          'application': this.application
        };
        this._formdataService.common(f, 'time').subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
              this.timezone_list = this._global.getVal(data, 'response.timeZone', '');
            }
            this.appCreateForm.get('timeZone').setValue(this.response.timeZone);
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
          this._formdataService.common(f, 'listStatusTypes').subscribe(
            data => {
              if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                this.status_list = this._global.getVal(data, 'response', '');
              }
              this.appCreateForm.get('status').setValue(this.response.status);
            },
            error => {
              console.log("error", JSON.stringify(error));
            });
        
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });


    });
    //this.is_owner=this._global.isOwner(this._global.getVal(this.response, 'id', ''));
  }
 
  ngOnInit() {

  }
  ngAfterViewInit() {
 
    this.ngxSmartModalService.getModal('quescreate').onCloseFinished.subscribe((event: Event) => {
      this.loadPoll();
    });
    this.ngxSmartModalService.getModal('ansedit').onCloseFinished.subscribe((event: Event) => {
      this.loadPoll();
    });
    this.ngxSmartModalService.getModal('anscreate').onCloseFinished.subscribe((event: Event) => {
      this.loadPoll();
    });
  }

  loadPoll(){
    this.questionForm={};
    let p = {
      'component': this.component,
      'application': this.application,
      'id':  this.pollId
    };
    this._viewService.application(p).subscribe(
      data => {

        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.response = this._global.getVal(data, 'response', '');
          this.pollJson=this.response['pollJson']['questions'];
        } },
        error => {
          console.log("error", JSON.stringify(error));
        });
  }

  update() {
    let tag = [];
    let p = this.appCreateForm.value;
    this.error = {  };
    this.btn_process = true;
    p['component'] = this.component;
    p['application'] = this.application;
    p = this._global.paramsRemoveNull(p);
    p['categoryJson'] = Helper.getCategoryChecboxValues("categoryCheck", '');
    p['id'] = this._global.getVal(this.response, 'id', '');

    if (p.startTime) {
      p.startTime = new Date(p.startTime).getTime();
    }
    if (p.endTime) {
      p.endTime = new Date(p.endTime).getTime();
    }
    this._pollService.update(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          
          
          this._global.showMessage({ type: severity, message: message });

          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  createQuestion(){

  this.ngxSmartModalService.getModal('quescreate').open();
   
  }
  questionEdit(obj){
    this.questionForm={};
    this.questionForm[obj['id']]=true;
  }
  questionEditcancel(){
    this.questionForm={};
  }
  updateQuestion(){
    this.qupdatebtn_process=true;
    this.error= {};
    let r = this.questionEditForm.value;
    r=this._global.paramsRemoveNull(r);
    this._pollService.updateQuestion(r ).subscribe(
      data => {
        let severity='success';
        let message='';
        if(this._global.getVal(data, 'status', '')==1){
          message=this._global.getVal(data, 'message.info', '');
          this._global.showMessage({type:severity,message:message});
          this.loadPoll();
        }else{
          this.qupdatebtn_process=false;
          message=this._global.getVal(data, 'message.error', '');
          severity='danger';
          for (let key in data["errors"]) {
            
            this.error[key] =this._global.getVal(data, 'errors.'+key+'.message', '');
            
          }
          this._global.showMessage({type:severity,message:message});
        }
      
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  createAnswer(qobj){
    this.questionId=qobj['id'];
    this.ngxSmartModalService.getModal('anscreate').open();
  }
  answerEdit(obj){
    this.answeresponse=obj;
    this.ngxSmartModalService.getModal('ansedit').open();
  }
 
}
